function plusXing(str, frontLen, endLen) {
	// var len = str.length - frontLen - endLen;
	var xing = "***";
	/* for (var i = 0; i < len; i++) {
		xing += '*';
	} */
	return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
}

function getQueryVariable() {
	var query = window.location.href;
	var vars = query.split("?")[1];
	let params = new URLSearchParams(vars);
	return params.get("code");
}

function getParams() {
	var params;
	var url = location.search;
	if (url.indexOf("?") == 0) {
		var paramArray = unescape(url).substring(1, url.length);
		console.log(paramArray);
		params = paramArray;
	}
	return params;
}

function formatDecimal(num, decimal) {
	num = num.toString();
	let index = num.indexOf(".");
	if (index !== -1) {
		num = num.substring(0, decimal + index + 1);
	} else {
		num = num.substring(0);
	}
	return parseFloat(num).toFixed(decimal);
}
function getDate(currentTime) {
	var second = 1;
	var minute = second * 60;
	var hour = minute * 60;
	var day = hour * 24;
	var month = day * 30;
	var monthC = currentTime / month;
	var weekC = currentTime / (7 * day);
	var dayC = currentTime / day;
	var hourC = currentTime / hour;
	var minC = currentTime / minute;
	var secondC = currentTime / second;
	var res = "";
	var nowTime=Date.parse(new Date())
	if (monthC >= 12) {
		var oldTime = nowTime - currentTime;
		var date = new Date(oldTime);
		res = date.getFullYear() + '-' + (date.getMonth() + 1) + '' + date.getDate();
	} else if (monthC >= 1) {
		res = parseInt(monthC) + '个月前';
	} else if (weekC >= 1) {
		res = parseInt(weekC) + '周前'
	} else if (dayC >= 1) {
		res = parseInt(dayC) + '天前'
	} else if (hourC >= 1) {
		res = parseInt(hourC) + '个小时前'
	} else if (minC >= 1) {
		res = parseInt(minC) + '分钟前'
	} else {
		res = parseInt(secondC) + '秒前'
	}
	return res;
}
module.exports = {
	plusXing,
	getParams,
	getQueryVariable,
	formatDecimal,
	getDate
};
